import { styled, Card, IconButton, Typography } from '@material-ui/core'

const CONTACT_WRAPPER_HEIGHT = 125

export const ContactWrapper = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: CONTACT_WRAPPER_HEIGHT,
  borderRadius: 10,
  borderLeft: `10px solid ${theme.palette.primary.main}`,
  backgroundClip: 'padding-box',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
  padding: theme.spacing(0.3, 2),
  marginBottom: theme.spacing(2),
}))

export const HeaderSection = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
    fontSize: 20,
  },
}))

export const EditButton = styled(IconButton)(({ theme }) => ({
  marginLeft: theme.spacing(0.5),
}))

export const Title = styled(Typography)({
  width: '100%',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  fontWeight: 600,
})
